
import moment from 'moment';
import { Component, Vue, Emit, Mixins } from 'vue-property-decorator';
import { GameArea } from '@/mixins/game_area';
import { PageQuery } from '@/mixins/page_query';
import { getNodeAnalysis } from '@/api/statistics';
import { iSelectOptionsList } from '@/interface/cancel-detail';
import LogUtils from 'panda-log';
import ShortcutDate from '@/components/shortcutdate/shortcutdate.vue';
import { formatterTimeByHouerAndMinutes } from '@/utils/common';
@Component({
  components: { ShortcutDate },
  filters: {
    timeDuration(data: number) {
      return formatterTimeByHouerAndMinutes(data);
    },
  },
})
export default class DataTable extends Mixins(GameArea, PageQuery) {
  @Emit() goto(obj: object) {
    LogUtils.info(obj);
  }
  private init = 0;
  private start!: any;
  private end!: any;
  public dates: (string | Date)[] = [];
  private totalBoot = 0;
  private totalConnect = 0;
  private pickerBeginDateBefore: { disabledDate: Function } = {
    disabledDate(time: any) {
      return time.getTime() > Date.now() - 3600 * 1000 * 24;
    },
  };
  private lengthTable = [];
  defaultDays: { day: number; initDay: number } = { day: 7, initDay: 1 }; // 默认近7天
  // 网吧表格
  private nodeTable = [];
  //快捷日期:
  private shortcutDays: iSelectOptionsList[] = [
    { label: '昨日', value: 1 },
    { label: '近7天', value: 7 },
    { label: '近15天', value: 15 },
    { label: '近30天', value: 30 },
    { label: '统计数据不包含当天', value: 0 },
  ];
  private sortTabel: iSelectOptionsList[] = [
    { label: '订单总数', value: 1 },
    { label: '单终端订单数', value: 2 },
    { label: '撤单数', value: 3 },
    { label: '撤单率', value: 8 },
    { label: '消耗云币', value: 4 },
    { label: '单终端消耗云币', value: 5 },
    { label: '消耗周期卡时长', value: 6 },
    { label: '消耗体验时长', value: 7 },
  ];
  private initDay: number | string = 1;
  private initSort = 0;
  loading: boolean = false;
  sort_by: number = 1;
  nodeParams: { sort_by: number; start: number; end: number } = {
    sort_by: 1,
    start: 0,
    end: 0,
  };
  /**
   * 设置时间
   */
  getShortcutTimeFn(dates: (string | Date)[], params: { start: number; end: number }, activeIndex: number) {
    this.initDay = activeIndex;
    this.dates = dates;
    this.nodeParams.start = params.start;
    this.nodeParams.end = params.end;
    // this.params.page = 1;
    this.getNodeInfo();
  }
  // 排序
  sortHandle(sort: number, index: number) {
    this.nodeParams.sort_by = sort;
    this.initSort = index;
    this.getNodeInfo();
  }
  dateHandler(datavalue: Date[]) {
    this.initDay = '';
    this.nodeParams.start = Math.floor(datavalue[0].getTime() / 1000);
    this.nodeParams.end = Math.floor(datavalue[1].getTime() / 1000) + 3600 * 24 - 1;
    // this.page = 1;
    this.getNodeInfo();
  }
  goToArea(row: any) {
    this.$router.push({
      name: 'node-device',
      query: {
        area_id: row.node_id,
      },
    });
  }
  async getNodeInfo() {
    this.loading = true;
    try {
      const res = await getNodeAnalysis(this.nodeParams);
      if (res && res.code === 0) {
        this.nodeTable = res.data;
      }
      this.loading = false;
    } catch (error) {
      LogUtils.debug(error);
      this.loading = false;
    }
  }

  mounted() {}
}
